import { ContainerScroll, CardSticky } from "@/components/ui/cards-stack"
import { Button } from "@/components/ui/button"
import { Link } from "react-router-dom"
import { useScrollAnimation } from "@/hooks/useScrollAnimation"
import { motion } from "motion/react"

const WHY_US_REASONS = [
  {
    id: "reason-1",
    title: "אחריות מלאה",
    description:
      "אנו מעניקים אחריות מלאה על כל המוצרים שלנו. כל תכשיט עובר בדיקת איכות קפדנית ומגיע עם אחריות יצרן מקיפה. אתם יכולים לסמוך עלינו לאורך זמן.",
    number: "01",
  },
  {
    id: "reason-2",
    title: "תמיכה אישית",
    description:
      "הצוות שלנו זמין עבורכם תמיד. אנו מספקים ייעוץ אישי, עוזרים בבחירת התכשיט המושלם ונותנים מענה מהיר לכל שאלה. השירות שלנו לא נגמר אחרי הרכישה.",
    number: "02",
  },
  {
    id: "reason-3",
    title: "איכות ללא פשרות",
    description:
      "אנו עובדים רק עם חומרי גלם מהשורה הראשונה ויהלומים באיכות הגבוהה ביותר. כל תכשיט מיוצר בקפידה רבה על ידי אומנים מיומנים ועומד בסטנדרטים הבינלאומיים המחמירים ביותר.",
    number: "03",
  },
  {
    id: "reason-4",
    title: "מחירים הוגנים",
    description:
      "אנו מאמינים ששירות איכותי ומוצרים יוקרתיים לא חייבים לבוא עם מחיר מופקע. אנו מציעים מחירים הוגנים ותחרותיים, ללא ויתור על האיכות והשירות שאתם מגיעים לכם.",
    number: "04",
  },
  {
    id: "reason-5",
    title: "עיצוב ייחודי",
    description:
      "הקולקציות שלנו משלבות עיצוב קלסי עם מגע מודרני וייחודי. אנו מציעים גם שירות עיצוב אישי, כך שתוכלו ליצור תכשיט שמשקף את האישיות והסגנון הייחודיים שלכם.",
    number: "05",
  },
]

const WhyUs = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });
  
  return (
    <div 
      ref={ref as React.RefObject<HTMLDivElement>}
      className="container bg-gradient-to-b from-background via-primary/5 to-background px-8 md:px-12 lg:px-16 py-20" 
      dir="rtl"
    >
      <div className="grid md:grid-cols-2 md:gap-12 xl:gap-16">
        <motion.div 
          className="md:sticky md:top-36 md:self-start"
          initial={{ opacity: 0, x: 50 }}
          animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-xs uppercase tracking-[0.3em] text-primary/60" style={{ fontWeight: 300 }}>
            למה אנחנו?
          </p>
          <h2 className="mb-6 mt-4 text-4xl tracking-tight" style={{ fontWeight: 300 }}>
            מה הופך אותנו{" "}
            <span className="text-primary">למיוחדים</span>
          </h2>
          <p className="max-w-prose text-sm text-muted-foreground mb-8" style={{ fontWeight: 300 }}>
            אנו לא רק מוכרים תכשיטים - אנו יוצרים חוויה מושלמת מתחילת הדרך ועד הרבה אחרי הרכישה. הלקוחות שלנו נהנים משירות יוצא דופן, איכות ללא פשרות ותמיכה שנמשכת לאורך זמן.
          </p>
          <Link to="/collections/all">
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground" style={{ fontWeight: 300 }}>
              לצפייה בכל המוצרים
            </Button>
          </Link>
        </motion.div>
        <ContainerScroll className="min-h-[200vh] space-y-8 py-16">
          {WHY_US_REASONS.map((reason, index) => {
            // Account for fixed header: increased offset for better visibility
            const mobileTop = 100 + (index + 2) * 10;
            const desktopTop = 160 + (index + 2) * 10;
            
            return (
              <CardSticky
                key={reason.id}
                index={index + 2}
                incrementY={10}
                className="rounded-lg border border-primary/20 bg-card/80 p-8 shadow-lg backdrop-blur-sm elegant-border lg:!top-[var(--desktop-top)]"
                style={{ 
                  top: mobileTop,
                  ['--desktop-top' as string]: `${desktopTop}px`
                }}
              >
                <div className="flex items-center justify-between gap-4 mb-6">
                  <h2 className="text-2xl tracking-tight" style={{ fontWeight: 300 }}>
                    {reason.title}
                  </h2>
                  <h3 className="text-2xl text-primary/60" style={{ fontWeight: 300 }}>
                    {reason.number}
                  </h3>
                </div>

                <p className="text-foreground/80 text-sm leading-relaxed" style={{ fontWeight: 300 }}>
                  {reason.description}
                </p>
              </CardSticky>
            );
          })}
        </ContainerScroll>
      </div>
    </div>
  )
}

export default WhyUs
